import { createSlice } from "@reduxjs/toolkit";

const initState = {
  complaints: 0,
  orgs: 0,
  req: 0,
};

export const countSlice = createSlice({
  name: "count",
  initialState: initState,
  reducers: {
    setCountReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetCountReducer: () => initState,
  },
});

export const { setCountReducer, resetCountReducer } = countSlice.actions;

export default countSlice.reducer;
